import axios from "axios";

const APIAUTH_URL = `${process.env.REACT_APP_API_AUTH}/admin`;
console.log("APIAUTH_URL:", APIAUTH_URL);

let auth = null;
let refreshPromise = null;

export const injectAuth = (authInstance) => {
  auth = authInstance;
};

const apiClient = axios.create({
  baseURL: APIAUTH_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

// ==============================
// 🟢 REQUEST INTERCEPTOR
// ==============================
apiClient.interceptors.request.use(
  (config) => {
    if (!config.headers?.Authorization && auth?.user?.access_token) {
      config.headers.Authorization = `Bearer ${auth.user.access_token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ==============================
// 🔄 RESPONSE INTERCEPTOR
// ==============================

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // No hay auth o no es 401 → propaga error
    if (!auth || error.response?.status !== 401 || originalRequest._retry) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      if (!refreshPromise) {
        refreshPromise = auth.signinSilent().finally(() => {
          refreshPromise = null;
        });
      }

      const user = await refreshPromise;

      if (!user?.access_token) {
        throw new Error("No access token after refresh");
      }

      // Reinyecta token y reintenta
      originalRequest.headers.Authorization = `Bearer ${user.access_token}`;
      return apiClient(originalRequest);
    } catch (refreshError) {
      auth.removeUser(); // logout duro
      return Promise.reject(refreshError);
    }
  }
);

export default apiClient;
